import { ToastContainer } from '../../components/Common';
import DealerOrderDetailsPage from './page';

const DealerOrderDetailsPageWrapper = () => {
	return (
		<>
			<div className="page-content">
				<DealerOrderDetailsPage />
			</div>
			<ToastContainer />
		</>
	);
};

export default DealerOrderDetailsPageWrapper;
